import { render, staticRenderFns } from "./ideavr.vue?vue&type=template&id=91921e58&scoped=true&"
import script from "./ideavr.vue?vue&type=script&lang=js&"
export * from "./ideavr.vue?vue&type=script&lang=js&"
import style0 from "./ideavr.vue?vue&type=style&index=0&id=91921e58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91921e58",
  null
  
)

export default component.exports